import {
    Box,
    Grid,
} from "@chakra-ui/react";

import ActivateAccountForm from "./components/ActivateAccountForm";
import LoginShowcase from "../Login/components/LoginShowcase";

const ActivateAccount = () => {
    return (
        <Box
            minH="100vh"
            h={{
                base: "auto",
                lg: "100vh",
            }}
            bg="#F8FAFC"
            overflowY={{
                base: "auto",
                lg: "hidden",
            }}
        >
            <Box
                w="100%"
                h={{
                    base: "auto",
                    lg: "100%",
                }}
                bg="white"
            >
                <Grid
                    h={{
                        base: "auto",
                        lg: "100%",
                    }}
                    minH={{
                        base: "100vh",
                        lg: "100%",
                    }}
                    templateColumns={{
                        base: "1fr",
                        lg: "1fr 1fr",
                    }}
                >
                    <ActivateAccountForm />
                    <LoginShowcase />
                </Grid>
            </Box>
        </Box>
    );
};

export default ActivateAccount;